import { combineReducers, createStore } from "redux";

import { composeWithDevTools } from "redux-devtools-extension";

import playerReducer from "./reducers/PlayerReducer";

import calendarManagementReducer from "./reducers/CalendarManagementReducer";
import companyDirectoryReducer from "./reducers/CompanyDirectoryReducer";
import infoReducer from "./reducers/InfoReducer";
import knowledgeBaseReducer from "./reducers/KnowledgeBaseReducer";

const rootReducer = combineReducers({
  player: playerReducer,
  info: infoReducer,
  companyDirectory: companyDirectoryReducer,
  calendarManagement: calendarManagementReducer,
  knowledgeBase: knowledgeBaseReducer,
});

const store = createStore(rootReducer, composeWithDevTools());

export default store;
